export const LOGIN_DETAILS_RECEIVED = 'LOGIN_DETAILS_RECEIVED';
export const UPDATE_SELECTED_WIDGET = 'UPDATE_SELECTED_WIDGET';
export const URL_BREAK = 'URL_BREAK';
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';
